module.exports = __webpack_public_path__ + "static/media/cicchetti_thumb_even.6aa7dc1e.jpg";